import React, { useState, useEffect } from 'react'

import Header from '../../components/header/index'
import About from '../../components/home/about/index'
import Courses from '../../components/home/courses/index'
import Footer from '../../components/footer/index'
import Cookies from '../../components/cookies/index'
import {Helmet} from "react-helmet";

import { getPageContent, getSocialMedias } from '../../services/api'
import ReactDOM from 'react-dom';

export default function Home() {
  const [pageContent, setPageContent] = useState()
  const [socialMedias, setSocialMedias] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    
    getSocialMedias().then((response) => {
      setSocialMedias(response.data);
    })

    getPageContent().then((response) => {
      setLoading(true)
      setPageContent(response.data);
      
      setTimeout(() => {
        const el = document.querySelector('.scripts');
        el.appendChild(document.createRange().createContextualFragment(response.data.extra_content_script ));
      }, 500);
 
    
    }).finally(() => {
      setLoading(false)
    });
  }, [])

  return (
    <>
      <Header bannerContent={pageContent} loading={loading} />
      <About aboutContent={pageContent} loading={loading} />
      <Courses pageContent={pageContent} />
      <Cookies />
      <Footer pageContent={pageContent} socialMedias={socialMedias} />
      <Helmet>
        <style>
          {pageContent?.extra_content_css}
        </style>
      </Helmet>
 
      <div className='scripts'></div>
    </>
  )
}
